import { PRACTICE } from '../../../../constants/assessmentItemType';
import selectors from '../../../../rootSelectors';
import { activateReadyForNextScreen } from '../../../../common/questions/questionsActions';
import { blockScreen, greyOutScreen, unblockScreen } from '../../../../common/screen/screenActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import { narrateReset, narrateStart } from '../../../../common/audio/audioActions';
import { goToCountdown } from '../../../../common/navigation/navigationActions';
import { VOCAB } from '../../../../constants/measure';
import { autoplayScript } from '../../vocabBDActions';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';

export const narratePracticeScreen = stimulusAudio => async (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);

    dispatch(blockScreen());
    dispatch(narrateStart());

    await dispatch(
        playAvatarAudio([VOCAB_AUDIO_INSTRUCTIONS[language].vocabBDPracticeInstructionStart]),
    );
    await dispatch(autoplayScript(0, stimulusAudio, PRACTICE));

    dispatch(narrateReset());
    dispatch(unblockScreen());
};

export const onNextPracticeButtonClick = () => (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);

    dispatch(blockScreen());
    dispatch(greyOutScreen());

    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        return dispatch(
            playAvatarAudio([VOCAB_AUDIO_INSTRUCTIONS[language].vocabBDPracticeReadyInstruction]),
        ).then(() => {
            dispatch(setAvatarInstructions(VOCAB_AUDIO_INSTRUCTIONS[language].clickOk));
            dispatch(activateReadyForNextScreen());

            return dispatch(unblockScreen());
        });
    }

    return dispatch(goToCountdown(VOCAB.ASSESSMENT, VOCAB.BD));
};
